import { Dispatch, useMemo } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { SurveyActions } from './actionTypes';
import Dispatcher from './dispatcher';
import selector from './selector';

const useSurvey = () => {
    const dispatch = useDispatch<Dispatch<SurveyActions>>();
    const dispatcher = useMemo(()=>new Dispatcher(dispatch), [dispatch]);
    const state = useSelector(selector, shallowEqual);

    return { state, dispatcher };
}

export default useSurvey;
